import { defineStore } from "pinia";
import { ref,reactive } from "vue";
import api from "@/services/api";


import { useCartStore } from "./cart";
import { useRouter } from "vue-router";



export const useAuthStore = defineStore("authenticate", () => {
  const user = ref(JSON.parse(localStorage.getItem("user")) || null);
  const token = ref(localStorage.getItem("auth_token") || null);


   // ✅ Check if logged in
  const isLoggedIn = () => {
    return !!(user.value && token.value);
  };

  // ✅ Login function
  const login = async (credentials) => {
    try {
      const cartStore = useCartStore();

      // 🟢 Guest cart token bhi bhejna
      const payload = {
        ...credentials,
        guest_token: cartStore.studenttoken,
      };

      const res = await api.post("/studentlogin", payload);

      if (res.data.status === "success") {
        user.value = res.data.user;
        token.value = res.data.token;

        // ✅ LocalStorage me save
        localStorage.setItem("auth_token", token.value);
        localStorage.setItem("user", JSON.stringify(user.value));

          
         // 🟢 Ab guest token ko user ke stoken se replace karosky
      if (res.data.user?.stoken) {
        cartStore.studenttoken = res.data.user.stoken;
        localStorage.setItem("studenttoken", res.data.user.stoken);
      }
    
        // ✅ Cart ko sync karo
        await cartStore.fetchCart();
      }

      return res.data;
    } catch (error) {
      // 🔴 Error logs
      if (error.response) {
        console.error("🔴 Login API Error:", error.response.data);
      } else {
        console.error("🔴 Login Error:", error.message);
      }
      throw error; // component handle karega
    }
  };

  // ✅ Logout function
  const logout = async () => {
  const cartStore = useCartStore();
  const authStore = useAuthStore(); 
    try {
      // ✅ Clear auth state
      authStore.user = null;
      authStore.token = null;

      // ✅ Remove from localStorage
      localStorage.removeItem("auth_token");
      localStorage.removeItem("authToken");
      localStorage.removeItem("studenttoken");
      localStorage.removeItem("user");

     
    // 3. Reset cart state
      cartStore.resetCart();

    

    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return { user, token, login, logout,isLoggedIn };
});
